import { PRODUCER_ZONE_URL_SEGMENT } from 'modules/producers/helpers/producers.const';

export function getProducerMainPageUrlBySlug(producerSlug: string): string {
    return `/${PRODUCER_ZONE_URL_SEGMENT}/${producerSlug}`;
}

export function getProducerUrl(
    url: string,
    producerSlug: string
): string {
    return `/${PRODUCER_ZONE_URL_SEGMENT}/${producerSlug}${url}`;
}

export function getProducerTabUrl(
    producerSlug: string,
    tabSlug: string
): string {
    return `/${PRODUCER_ZONE_URL_SEGMENT}/${producerSlug}/tab/${tabSlug}`;
}
